import React from 'react';

import { InfoMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';

import { StringKeyValue } from '../../actions/types';
import ProductImage from '../../components/ProductImage/ProductImage';
import { CompletionReducer } from '../../reducers/completion';

interface Props {
    completion: CompletionReducer;
    text: StringKeyValue;
}

const LoanApproved = ({ completion, text }: Props): JSX.Element => {
    const { applicationId } = completion.ongoing;

    const {
        receiptApprovedTitle,
        receiptApprovedP1,
        receiptApprovedP2,
        receiptApprovedP3,
        receiptApprovedP4,
        receiptApprovedP5,
        receiptApprovedInfoBox,
    } = text;

    return (
        <>
            {receiptApprovedTitle && (
                <ProductImage className="receipt__header" image="Heart" title={receiptApprovedTitle} />
            )}

            <div className="receipt__content">
                <div className="default-margin">
                    {receiptApprovedP1 && applicationId && (
                        <p>
                            <strong>{receiptApprovedP1}</strong> {applicationId}
                        </p>
                    )}
                    {/*
                        TODO: Add Loan Details
                        TODO: Add Vehicle Details
                    */}
                    {receiptApprovedP2 && <p>{receiptApprovedP2}</p>}
                    {receiptApprovedP3 && <p>{receiptApprovedP3}</p>}
                    {receiptApprovedP4 && <p>{receiptApprovedP4}</p>}
                    {receiptApprovedP5 && <p>{receiptApprovedP5}</p>}
                </div>
            </div>

            <InfoMessage className="receipt__info" text={receiptApprovedInfoBox} icon={IconTypes.LYSPAERE_24} />
        </>
    );
};
export default LoanApproved;
